// @vuese
// Mixin edycji wielu wierszy w tabeli
export const tableMultipleMixin = {
  methods: {
    // @vuese
    // Zaznaczenie wszystkich
    checkAll(value) {
      this.list.map(object => this.$set(object, 'checked', value));
    }
  },
  computed: {
    checkedList() {
      return this.list.filter(listItem => listItem.checked === true);
    }
  }
};
